import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M10 15V9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 15V9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M7.714 2h8.572L22 7.714v8.572L16.286 22H7.714L2 16.286V7.714L7.714 2z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "PauseOctagon";
const PauseOctagon = memo(themed(Icon));
export {
  PauseOctagon
};
//# sourceMappingURL=pause-octagon.js.map
